<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <g clip-path="url(#clip0_6862_6182)">
      <path d="M10.2857 10.2857H12V12H10.2857V10.2857Z" fill="rgb(var(--v-theme-text))" />
      <path d="M6.85714 10.2857H8.57143V12H6.85714V10.2857Z" fill="rgb(var(--v-theme-text))" />
      <path d="M3.42857 10.2857H5.14286V12H3.42857V10.2857Z" fill="rgb(var(--v-theme-text))" />
      <path d="M0 10.2857H1.71429V12H0V10.2857Z" fill="rgb(var(--v-theme-text))" />
      <path d="M10.2857 6.85714H12V8.57143H10.2857V6.85714Z" fill="rgb(var(--v-theme-text))" />
      <path d="M6.85714 6.85714H8.57143V8.57143H6.85714V6.85714Z" fill="rgb(var(--v-theme-text))" />
      <path d="M3.42857 6.85714H5.14286V8.57143H3.42857V6.85714Z" fill="rgb(var(--v-theme-text))" />
      <path d="M10.2857 3.42857H12V5.14286H10.2857V3.42857Z" fill="rgb(var(--v-theme-text))" />
      <path d="M6.85714 3.42857H8.57143V5.14286H6.85714V3.42857Z" fill="rgb(var(--v-theme-text))" />
      <path d="M10.2857 0H12V1.71429H10.2857V0Z" fill="rgb(var(--v-theme-text))" />
    </g>
    <defs>
      <clipPath id="clip0_6862_6182">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
